import { render, staticRenderFns } from "./VideoOrImageOrNone.vue?vue&type=template&id=57c20628&"
import script from "./VideoOrImageOrNone.vue?vue&type=script&lang=js&"
export * from "./VideoOrImageOrNone.vue?vue&type=script&lang=js&"
import style0 from "./VideoOrImageOrNone.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
